/**
 * Obfuscates a secret for display: keeps a short prefix and the last few chars,
 * masking every hidden character with a dot so the mask reflects the real key
 * length (e.g. `ocp_687e••••…••••sNk2`). Pass `*` to force a fixed count.
 * The full value is only ever shown when the user explicitly reveals it.
 * Short strings (nothing left to hide) are returned unchanged.
 */
export function maskKey(
  key: string,
  { prefix = 8, suffix = 4, dots }: { prefix?: number; suffix?: number; dots?: number } = {},
): string {
  if (key.length <= prefix + suffix) return key;
  const count = dots ?? key.length - prefix - suffix;
  return `${key.slice(0, prefix)}${'*'.repeat(count)}${key.slice(-suffix)}`;
}
